import {LocaleRepository} from "./locale.repository";
import {LocaleFactory} from "./locale.factory";
import {LocaleApiModel} from "../../models/locale/locale.api-model";
import {LocaleDomainModel} from "../../models/locale/locale.domain-model";
import {BaseDomainService} from "../../../../infrastructure/domain-services/base-domain-service";
import {LanguageRepository} from "../language/language.repository";
import {LanguageFactory} from "../language/language.factory";
import {LanguageDomainModel} from "../../models/language/language.domain-model";
import {DomUtils} from "../../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../../core/bootstrap/models/site-config";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {AppStore} from "../../../../core/app/app-store";
import {NavigationManager} from "../../../../core/managers/navigation-manager";
import {HistoryManager} from "../../../../core/managers/history-manager";
import {LocalStorageUtils} from "../../../../infrastructure/utils/local-storage.utils";
import {CookieManager} from "../../../../core/managers/cookie-manager";
import {BaseDomainParams} from "../../../../infrastructure/models/params/base-domain-params";
import {DomainRequestManager} from "../../../../core/managers/domain-request-manager";
import {LOCAL_STORAGE_KEYS} from "../../../../core/consts";
import DATE_FORMATS from '../../../../core/app/consts/date-formats';
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";

export class LocaleDomainService extends BaseDomainService {
  repository: LocaleRepository;
  factory: LocaleFactory;
  languageRepository: LanguageRepository;
  languageFactory: LanguageFactory;
  items: Array = [];

  static injectables = [...BaseManagedService.injectables, LocaleRepository, LocaleFactory, DomainRequestManager, LanguageRepository, LanguageFactory, CookieManager];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    device: DeviceViewModel,
    appStore: AppStore,
    navigationManager: NavigationManager,
    historyManager: HistoryManager,
    localStorageUtils: LocalStorageUtils,
    repository: LocaleRepository,
    factory: LocaleFactory,
    requestManager: DomainRequestManager,
    languageRepository: LanguageRepository,
    languageFactory: LanguageFactory,
    cookieManager: CookieManager
  ) {
    super(domUtils, logger, siteConfig, device, appStore, navigationManager, historyManager, localStorageUtils, repository, factory, requestManager);


    this.languageFactory = languageFactory;
    this.languageRepository = languageRepository;
    this.cookieManager = cookieManager;
  }

  get languages(): Array<LanguageDomainModel> {
    return this.languageRepository.languages
  }

  get dateFormats() {
    return DATE_FORMATS;
  }

  get locale(): LocaleDomainModel {
    return this.items[0];
  }

  findLangByDisplayName(name: String): LanguageDomainModel {
    return this.languages.find(x => x.displayName === name);
  }

  async fetch(params: BaseDomainParams): LocaleDomainModel {
    const cultureName: String = params.requestParams.cultureName;
    const locale: LocaleApiModel = this.factory.createApiModel({}, cultureName);
    const language: LanguageDomainModel = await this.languageRepository.fetch(locale);

    const storedCountryId: Number = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.userCountryId);
    const cookieCountryId: Number= this.cookieManager.localDataCookie.countryId;
    const fetchCountryId: Number = await this.fetchUserCountryId(params);
    const widgetInputParam: Number = this.appSettings.userCountryId;

    if(storedCountryId > 0) {
      locale.userCountryId = storedCountryId;
    } else if (widgetInputParam > 0) {
      locale.userCountryId = widgetInputParam;
    } else if (cookieCountryId > 0) {
      locale.userCountryId = cookieCountryId;
    } else if (fetchCountryId > 0) {
      locale.userCountryId = fetchCountryId;
    } else {
      locale.userCountryId = -1;
    }

    const localeDomain: LocaleDomainModel = this.factory.createDomainModel(locale, language);

    this.items.length = 0;
    this.items.push(localeDomain);

    return Promise.resolve(localeDomain);
  }

  async fetchUserCountryId(params: BaseDomainParams) {
    let fetchCountryId = null;

    if(this.appSettings.bootstrapSettings.useClientUserCountryId) {
      const localeDomainFetch: LocaleDomainModel = await super.fetch(params);
      fetchCountryId = localeDomainFetch.userCountryId;
    }

    return fetchCountryId;
  }
}




